/*global angular, _*/

var termHelper = angular.module('termHelper', []);
termHelper.factory('termHelper', ['$uibModal', 'sriClient', 'settings', 'bibContentManager', function ($uibModal, sriClient, settings, bibContentManager) {
  'use strict';
  var that = {};

  that.replaceTerm = function (text) {
    var re;
    if (text) {
      re = new RegExp('<a href="\/content\/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})"(?:(?!<\\/?a).)*>((?:(?!<\/?a).)*)<\/a>', 'ig');
      return text.replace(
        re,
        '<term key="$1" word="$2"></term>'
      );
    }
  };
  that.removeTerm = function (text) {
    var re;
    if (text) {
      re = new RegExp('<a href="\/content\/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})"(?:(?!<\\/?a).)*>((?:(?!<\/?a).)*)<\/a>', 'ig');
      return text.replace(re, '$2');
    }
  };

  that.highlightTerm = function (text) {
    var re;
    if (text) {
      re = new RegExp('<a href="\/content\/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})"(?:(?!<\\/?a).)*>((?:(?!<\/?a).)*)<\/a>', 'ig');
      return text.replace(
        re,
        '<term key="$1" word="$2" mode="highlight"></term>'
      );
    }
  };

  that.openTerm = function (term, from) {
    $uibModal.open({
      animation: true,
      template: require('../../screen/modals/term.html'),
      controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
        $scope.loading = true;
        if(typeof term === 'string') {
          bibContentManager.getContent('/content/' + term)
            .then(function (response) {
              $scope.term = response;
              $scope.loading = false;
            }); 

        } else {
          $scope.term = term;
          $scope.loading = false;
        }
        $scope.from = from;
        $scope.close = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }]
    });
  };

  return that;
}]);
module.exports = termHelper;



// WEBPACK FOOTER //
// ./web/js/module/termHelper/termHelper.js